export default __webpack_public_path__ + "static/media/defaultImage.76092a20.svg";